import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { useAuth as n } from "@phx-husky/use-auth";
function e(n, e, t, i) {
  return new (t || (t = Promise))(function (o, c) {
    function r(n) {
      try {
        p(i.next(n));
      } catch (n) {
        c(n);
      }
    }
    function a(n) {
      try {
        p(i.throw(n));
      } catch (n) {
        c(n);
      }
    }
    function p(n) {
      var e;
      n.done ? o(n.value) : (e = n.value, e instanceof t ? e : new t(function (n) {
        n(e);
      })).then(r, a);
    }
    p((i = i.apply(n, e || [])).next());
  });
}
var t = function t() {
  var t = n();
  return {
    signUp: function signUp(n) {
      return e(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", t.signUp(n));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    validate: function validate(n) {
      return t.validate(n);
    },
    confirmSignUp: function confirmSignUp(n) {
      return t.confirmSignUp(n);
    },
    getSignUpFields: function getSignUpFields() {
      return t.getSignUpFields();
    },
    resendSignUpCode: function resendSignUpCode(n) {
      return t.resendSignUp(n);
    },
    getRecapchaKey: function getRecapchaKey() {
      return t.getRecapchaKey();
    }
  };
};
export { t as useSignUp };